import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css"; // Import CSS for AOS animations
import Icon1 from "/Images/iconxcrow1.svg";
import Icon2 from "/Images/iconxcrow2.svg";
import Icon3 from "/Images/iconxcrow3.svg";
import Icon4 from "/Images/iconxcrow4.svg";
import Icon5 from "/Images/iconxcrow5.svg";
import Icon6 from "/Images/iconxcrow6.svg";
import { useMediaQuery } from "@mui/material";

const Platform = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const isMobile = useMediaQuery("(max-width: 767px)");

  const platforms = [
    { iconSrc: Icon1, title: "Luxury Items", text: "Watches, jewellery, antiques and other valuables", delay: "100" },
    { iconSrc: Icon2, title: "Second-hand Goods", text: "Safe buying and selling in market places", delay: "110" },
    { iconSrc: Icon3, title: "Vehicles", text: "Cars, motorcycles, bicycles, boats and machines", delay: "120" },
    { iconSrc: Icon4, title: "Services", text: "Forwarding agents, and programming services", delay: "130" },
    { iconSrc: Icon5, title: "Digital Goods", text: "Internet domains or Web shop and Websites", delay: "140" },
    { iconSrc: Icon6, title: "Deposit", text: "Apartments, vehicles, and heavy machinery", delay: "150" },
  ];

  return (
    <section
      style={{
        background: "#E0DCD9",
        paddingTop: isMobile ? "2rem" : "4rem",
        paddingBottom: isMobile ? "4rem" : "6.5rem",
        padding: isMobile ? "2rem" : "4rem 5rem",
        fontFamily: "Poppins",
      }}
    >
      <div style={{ maxWidth: "1290px", margin: "0 auto", padding: isMobile ? "0 10px" : "0 20px", textAlign: "center" }}>
        <div style={{ marginBottom: "40px" }}>
          <h2
            style={{
              fontSize: isMobile ? "1.8rem" : "2.5rem",
              fontWeight: "bold",
              background: "linear-gradient(90deg, #2D669B 0%, #0582CA 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
              color: "transparent",
              maxWidth: isMobile ? "90%" : "770px",
              margin: "0 auto",
            }}
          >
            Xcrow Can Be Used for 
            Goods, Services and Deposits
          </h2>
        </div>

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: isMobile ? "10px" : "20px",
          }}
        >
          {platforms.map((platform, index) => (
            <div
              key={index}
              data-aos="fade-up"
              data-aos-delay={platform.delay}
              style={{
                width: isMobile ? "100%" : "390px",
                height: isMobile ? "auto" : "180px",
                backgroundColor: "#DCD7D4",
                borderRadius: "12px",
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                alignItems: "center",
                justifyContent: "center",
                padding: isMobile ? "20px" : "30px",
                textAlign: isMobile ? "center" : "left",
              }}
            >
              <div style={{ display: "flex", flexDirection: isMobile ? "column" : "row", alignItems: "center", gap: "15px" }}>
                <img
                  src={platform.iconSrc}
                  alt={platform.title}
                  style={{
                    width: "50px",
                    height: "50px",
                    marginBottom: isMobile ? "10px" : "0",
                  }}
                />
                <div style={{ display: "flex", flexDirection: "column", alignItems: isMobile ? "center" : "flex-start" }}>
                  <h3 style={{ color: "#214D73", fontSize: isMobile ? "16px" : "20px", fontWeight: "600", margin: 0 }}>
                    {platform.title}
                  </h3>
                  <p style={{ color: "#555555", fontSize: isMobile ? "0.875rem" : "1rem", lineHeight: "1.4", marginTop: "5px" }}>
                    {platform.text}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Platform;
